import { Connection } from 'models'

export class SuperhogPublicProfile {

    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    avatar: string;
    billingTown: string;
    billingCountry: string;
    dateOfBirth: Date;
    joinDate: Date;
    connections: Connection[];
    reviewCount: number;
    isSuperhogMember: boolean;
    covidVaccine: boolean;
}